import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class WorkLocations extends Component {
    constructor() {
        super()
        this.state = {
            workLocationsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDepartmentList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getDepartmentList = () => {
        apiService.getWorkLocationsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        workLocationsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.workLocationsList).map((value,index) => {
            
            return {
                label : this.state.workLocationsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Work Location"
                options={list}
                onChange={(e) => { (e) ? this.props.workLocationChange(e) : this.props.workLocationChange([])}}
                />
            </div>
        )
    }
}
export default WorkLocations


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/WorkLocations.js